import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import "@fontsource/ibm-plex-mono/600.css";
import "@fontsource/ibm-plex-mono/700.css";
import "@fontsource-variable/source-serif-4";
import "@/index.css";
import "@/subscriber_facing/styles/sponsorships.css";
import "vite/modulepreload-polyfill";

document.addEventListener("DOMContentLoaded", function () {
  const skuElements = document.querySelectorAll(".sponsorships-sku");

  skuElements.forEach((element) => {
    element.addEventListener("click", function () {
      // Toggle active state
      const wasActive = this.classList.contains("active");

      // Remove active from all SKUs and hide all slots
      skuElements.forEach((el) => {
        el.classList.remove("active");
        const slots = el.querySelector(".sponsorships-slots");
        if (slots) {
          slots.classList.remove("visible");
        }
      });

      // If this SKU wasn't active, activate it and show slots
      if (!wasActive) {
        this.classList.add("active");
        const slotsContainer = this.querySelector(".sponsorships-slots");
        if (slotsContainer) {
          slotsContainer.classList.add("visible");
        }
      }
    });
  });
});
